import { Button } from "@/components/ui/baseUi/button"
import { BoxFormHeader } from "@modules/box/components/boxCreationForm/boxFormHeader"
import { BoxFormPageNumber } from "@modules/box/components/boxCreationForm/boxFormPageNumber"
import { word } from "@modules/core/utils/i18n"
import { ArrowLeft, ArrowRight } from "lucide-react"
import { type ReactNode } from "react"

type BoxFormTemplatePageProps = {
  onPrevious: () => void
  handleSubmit: () => void
  disabled: boolean
  pageNumber?: number
  children: ReactNode
  header: {
    title: string
    subtitle?: string
    description?: string
    children?: ReactNode
  }
}

export function BoxFormTemplatePage({
  onPrevious,
  handleSubmit,
  disabled,
  pageNumber,
  children,
  header,
}: BoxFormTemplatePageProps) {
  return (
    <>
      <BoxFormHeader title={header.title} subtitle={header.subtitle} description={header.description}>
        {header.children}
      </BoxFormHeader>

      <div style={{ maxWidth: "32.5rem" }} className="flex w-full flex-col gap-6">
        {children}
      </div>

      <div className="flex w-full flex-col items-center gap-3 sm:flex-row">
        <div className="flex w-full justify-center gap-2">
          <Button onClick={onPrevious} size="lg" variant="outline">
            <ArrowLeft size={18} color="currentColor" />
            {word("global.previous")}
          </Button>
          <Button onClick={handleSubmit} disabled={disabled} variant="primary" size="lg">
            {word("global.continue")}
            <ArrowRight size={18} color="currentColor" />
          </Button>
        </div>

        {pageNumber && <BoxFormPageNumber pageNumber={pageNumber} disabled={disabled} />}
      </div>
    </>
  )
}
